export function logError(error, customAttributes) {
  if (window.newrelic) {
    window.newrelic.noticeError(error, customAttributes);
  } else {

  }
}


// WEBPACK FOOTER //
// ./src/js/logError.js